module.exports = __webpack_public_path__ + "static/RingSavvy-ICB-Hero-b92607de6c24b5ee25d3eab6e5e33afc.jpg";